import React, { useState, useEffect } from 'react';
import {
	TextField,
	Typography,
	IconButton,
	FormControl,
	FormLabel,
	Divider,
} from '@mui/material';
import Text from '../text';
import DropDownFields from '../drop-down/DropdownAdminSettings';
import DeleteConfirmationDialog from '../dialog/DeleteAccount';
import DataControlSettingsModal from '../dialog/DataControlSettingsModal';
import CONSTANTS from '../../utils/constants/UIConstants';
import countries from 'utils/constants/Countries';
import { addEventLog } from 'utils/functions/eventLogFunctions';
interface MyAccountProps {
	mode: 'online' | 'offline';
	userDetails: any;
	onUpdateUserDetails: (userDetails: any) => void;
}

const MyAccount: React.FC<MyAccountProps> = ({
	mode,
	userDetails,
	onUpdateUserDetails,
}) => {
	
	const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
	const [openDataControlDialog, setOpenDataControlDialog] = useState(false);

	const [selectedCountry, setSelectedCountry] = useState<string>(
		userDetails?.addressVO?.countryName
	);
	const handleSelectedCountry = (value: string) => {
		setSelectedCountry(value);
	};
	const [selectedIndustry] = useState<string>(
		userDetails?.industryName
	);

	const [firstName, setFirstName] = useState<string>(userDetails?.firstName);
	const [lastName, setLastName] = useState<string>(userDetails?.lastName);
	const [email, setEmail] = useState<string>(userDetails?.email);
	const [phone, setPhone] = useState<string>(
		userDetails?.addressVO?.officePhone
	);
	const [company, setCompany] = useState<string>(userDetails?.parentCompany);
	const [address, setAddress] = useState<string>(
		userDetails?.organizationVO?.orgAddress
	);
	const [userUpdate, setUserUpdate] = useState<any>([]);
	const isOffline = mode === 'offline';

	useEffect(() => {
		const updatedUserDetails = {
			...userDetails,
			firstName: firstName,
			lastName: lastName,
			email,
			addressVO: {
				...userDetails?.addressVO,
				officePhone: phone,
				countryName: selectedCountry,
			},
			industryName: selectedIndustry,
			organizationVO: {
				...userDetails?.organizationVO,
				brand: company,
				orgAddress: address,
			},
			parentCompany: company,
			fullName: `${firstName} ${lastName}`,
		};
		onUpdateUserDetails(updatedUserDetails);
		setUserUpdate(updatedUserDetails);
	}, [
		firstName,
		lastName,
		email,
		phone,
		selectedCountry,
		selectedIndustry,
		company,
		address,
	]);

	const handleDeleteGroup = async () => {};

	return (
		<div id="my-account">
			{mode === 'offline' && (
				<div
					style={{
						width: '736px',
						border: '1px solid #FFA726',
						backgroundColor: '#FFF4E5',
						padding: '8px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
						marginBottom: '10px',
						marginTop: '10px',
						marginRight: '20px',
					}}
				>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<img
							src="/assets/icons/Wifi-orange.svg"
							alt="Offline"
							style={{ marginRight: '10px' }}
						/>
						<Typography
							variant="body1"
							color="#66491F"
							className="!font-jost"
						>
							You're currently offline. Please reconnect to make
							changes.
						</Typography>
					</div>
					<IconButton sx={{ p: 0, mr: '5px', mt: '2px' }}>
						<img
							src="/assets/icons/Close.svg"
							alt="Remove"
							className="w-5 h-5 md:block hidden"
						/>
					</IconButton>
				</div>
			)}
			<Text addStyle="!text-[#2C2C2C] !font-inter !text-[20px] !mt-[24px] !font-semibold !mb-[10px]">
				My Account
			</Text>
			<div style={{ display: 'flex', marginTop: 20 }}>
				<FormControl>
					<FormLabel className="!font-inter !text-[12px]">
						First Name
					</FormLabel>
					<TextField
						size="small"
						defaultValue={firstName}
						onChange={(e) => {
							setFirstName(e.target.value);
						}}
						disabled={isOffline}
						style={{ width: 240, marginTop: 10, marginRight: 30 }}
						className="first-name "
						sx={{
							'& .MuiInputBase-root': {
								fontFamily: 'Jost, sans-serif',
							},
						}}
					/>
				</FormControl>
				<FormControl>
					<FormLabel className="!font-inter !text-[12px]">
						Last Name
					</FormLabel>
					<TextField
						size="small"
						defaultValue={lastName}
						onChange={(e) => {
							setLastName(e.target.value);
						}}
						disabled={isOffline}
						style={{ width: 240, marginTop: 10 }}
						className="last-name"
						sx={{
							'& .MuiInputBase-root': {
								fontFamily: 'Jost, sans-serif',
							},
						}}
					/>
				</FormControl>
			</div>
			<div style={{ display: 'flex', marginTop: 20 }}>
				<FormControl>
					<FormLabel className="!font-inter !text-[12px]">
						Company
					</FormLabel>
					<TextField
						size="small"
						defaultValue={company}
						onChange={(e) => {
							setCompany(e.target.value);
						}}
						disabled={isOffline}
						style={{ width: 240, marginTop: 10, marginRight: 30 }}
						className="company"
						sx={{
							'& .MuiInputBase-root': {
								fontFamily: 'Jost, sans-serif',
							},
						}}
					/>
				</FormControl>
				<DropDownFields
					label={'Country'}
					value={selectedCountry}
					onChange={handleSelectedCountry}
					options={countries}
					addStyle="!w-[240px] !mr-[30px] !mt-[10px] country !font-jost"
					disabled={isOffline}
				/>
			</div>
			<div style={{ display: 'flex', marginTop: 20 }}>
				<FormControl>
					<FormLabel className="!font-inter !text-[12px]">
						Email
					</FormLabel>
					<TextField
						size="small"
						defaultValue={email}
						style={{ width: 510, marginTop: 10, marginRight: 30 }}
						disabled
						className="email"
						sx={{
							'& .MuiInputBase-root': {
								fontFamily: 'Jost, sans-serif',
							},
						}}
					/>
				</FormControl>

				{}
			</div>
			<div style={{ display: 'flex', marginTop: 20 }}>
				{}
			</div>
			<div style={{ display: 'flex', marginTop: 0 }}>
				{}
			</div>
			<Divider
				variant="middle"
				style={{
					margin: '0px 0 10px 0',
					backgroundColor: CONSTANTS.APP_BACKGROUND_COLOR,
				}}
			/>
			<Text addStyle="!text-[#0092C8] !font-jost !text-[16px]"
				onClick={() => {
					addEventLog(`Data Control Settings Opened`, "Account Management", undefined, undefined);
					setOpenDataControlDialog(true);
				}}
				sx={{ cursor: 'pointer', color: '#0092C8', marginBottom: '15px', marginTop:'15px', width:'150px' }}>
				Data control settings
			</Text>
			<Text addStyle="!text-[#EA6861] !font-jost !text-[16px] "
				onClick={() => {
					addEventLog(`Delete Account Menu Opened`, "Account Management", undefined, undefined);
					setOpenDeleteDialog(true);
				}}
				sx={{ cursor: 'pointer', color: '#EA6861', width:'130px' }}>
				Delete account
			</Text>

			<DeleteConfirmationDialog
				open={openDeleteDialog}
				onClose={() => {
					addEventLog(`Delete Account Menu Closed`, "Account Management", undefined, undefined);
					setOpenDeleteDialog(false);
				}}
				onConfirm={handleDeleteGroup}
			/>
			<DataControlSettingsModal
				open={openDataControlDialog}
				onClose={() => {
					addEventLog(`Data Control Settings Closed`, "Account Management", undefined, undefined);
					setOpenDataControlDialog(false);
				}}
			/>
		</div>
	);
};

export default MyAccount;
